
const queueTypes = ['quorum', 'classic'];

const exchangeTypes = ['headers', 'direct', 'fanout'];

export const isQueueType = (type: string): boolean => {
  return queueTypes.includes(type);
}

export const isExchangeType = (type: string): boolean => {
  return exchangeTypes.includes(type);
}

export const bindingArgumentsComparison = (obj: any, other: any): boolean => {
  const a = obj || {};
  const b = other || {};
  return (Object.keys(a) as (keyof typeof a)[]).every((key) => {
    if (key === 'x-match-all' || key === 'x-match-any') {
      return true;
    }
    return (Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key]);
  });
};